import React from 'react';
import { Link } from 'react-router-dom';

export default function Breadcrumbs({ title, slug }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Forside",
        "item": "https://www.kanmanfryse.dk/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": title,
        "item": `https://www.kanmanfryse.dk/${slug}`
      }
    ]
  };

  return (
    <nav aria-label="Brødkrummesti" className="text-sm text-[#5C6670] mb-6">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <ol className="flex items-center space-x-2">
        <li>
          <Link to="/" className="text-[#2A4DB0] hover:underline">
            Forside
          </Link>
        </li>
        <li aria-hidden="true" className="text-[#5C6670]">
          →
        </li>
        <li aria-current="page" className="text-[#141B22] font-medium truncate">
          {title}
        </li>
      </ol>
    </nav>
  );
}
